const usePrintHtmlInNewWindow = (
  htmlContent: string,
  windowTitle = "Print Document",
) => {
  const printWindow = window.open("", "_blank", "width=800,height=600");
  if (!printWindow) {
    alert("Failed to open print window. Please allow pop-ups for this site.");
    return;
  }

  try {
    printWindow.document.write(htmlContent);
    printWindow.document.close();
  } catch (error: unknown) {
    console.error("Failed to write to print window:", error);
    alert("Failed to prepare the print document. Please try again.");
    return;
  }

  printWindow.onload = () => {
    try {
      // Adicionando um listener para detectar quando a impressão é cancelada ou concluída
      const beforePrint = () => {
        console.log("Preparando para imprimir...");
      };

      const afterPrint = () => {
        console.log("Impressão concluída ou cancelada");
        // Fechar apenas se a janela ainda existir
        if (printWindow && !printWindow.closed) {
          printWindow.close();
        }
      };

      printWindow.addEventListener("beforeprint", beforePrint);
      printWindow.addEventListener("afterprint", afterPrint);

      // Iniciar a impressão
      printWindow.print();
    } catch (error: unknown) {
      if (error instanceof Error) {
        console.error("Print failed:", error.message);
        alert(`Printing failed: ${error.message}`);
      } else {
        console.error("Print failed:", error);
        alert("Printing failed. Please try again.");
      }
    }
  };
};

export default usePrintHtmlInNewWindow;
